// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-content-container {\n  display: grid;\n  grid-template-columns: minmax(auto, 290px) 1fr;\n  grid-auto-flow: column;\n  position: relative;\n}\n.modal-column {\n  display: grid;\n  width: 100%;\n  padding: 0 12px 12px 12px;\n}\n", ""]);
// Exports
module.exports = exports;
